/**
 * Erstes freies Varianten-Label: A..Z, danach V27, V28 ... - dieselbe Regel wie
 * `naechstesLabel()` (apps/api/src/lib/altangebot.ts) und sql/712. Seit 12.10.2026 gibt es keine
 * Obergrenze mehr; das Label ist nur noch ein interner Schluessel (sichtbar ist der Titel).
 */
export function naechstesVariantenLabel(vorhanden: readonly string[]): string {
  for (let n = 1; ; n++) {
    const l = n <= 26 ? String.fromCharCode(64 + n) : `V${n}`;
    if (!vorhanden.includes(l)) return l;
  }
}
